import { FC } from 'react';

export const TrendsSeparator: FC = () => {
  return (
    <div className="w-full border-t border-dashed border-zinc-300 my-1"></div>
  );
};
